import { Component, OnInit } from '@angular/core';
import { TypeDeSorts } from 'src/app/_enums/typeDeSort';
import { Competence } from 'src/app/_models/competence';
import { Sort } from 'src/app/_models/sort';
import { AdminService } from 'src/app/_services/admin.service';
import { CompetenceService } from 'src/app/_services/competence.service';
import { SortService } from 'src/app/_services/sort.service';

@Component({
  selector: 'app-admin',
  templateUrl: './datadumpPersonnage.component.html',
  styleUrls: ['./datadumpPersonnage.component.scss']
})
export class AdminDatadumpPersonnageComponent implements OnInit {
  constructor(private adminService: AdminService, private competenceService: CompetenceService, private sortService: SortService) {}

  personnages!: any[];
  competences!: Competence[];
  sorts!: Sort[];
  public typeDeSorts = new TypeDeSorts;

  ngOnInit(): void {
    this.adminService.dataDumpPersonnage().subscribe(l => {
      this.personnages = l;
    });
      
    this.sortService.getSorts()          
    .subscribe({
      next: (sorts) => this.sorts = sorts,
    });
        
    this.competenceService.getCompetences()          
    //.pipe(first())
    .subscribe({
      next: (competences) => this.competences = competences,
    });
  }

  public getCompetencesPersonnage(personnage: any) {
    return personnage.competences.map((c: any) => {
      return {      
        competence: c,
        description: this.competences.find((comp) => comp.id === c.competenceId)
      };
    });
  }

  public getSortsPersonnage(personnage: any) {
    return Array.from(this.typeDeSorts.values.entries()).map((typeDeSort) => {
      return {
        name: typeDeSort[1],
        sorts: personnage.sorts.map((s: any) => {
          return {      
            sort: s,
            description: this.sorts
              .find((sort) => sort.id === s.sortId && sort.type === typeDeSort[0])
          };
        }).filter((sort: any) => sort.description != null)
      }
    }).filter((sortPersonnage) => sortPersonnage.sorts.length > 0);
  }
}
